(function ($) {

    //MOBILE MENU

    let html = $('html');
    let burger = $('.burger-menu');
    let nav = $('.top-nav');
    let navLink = $('.nav-links a');
    let mobileSearch = $('.mobile-search')

    burger.on('click', function () {
        if (burger.hasClass('active')){
            burger.removeClass('active')
            html.removeClass("scroll-lock");
        }else{
            html.addClass("scroll-lock");
            burger.addClass('active');
        }
        nav.toggleClass('nav-active');
        burger.addClass('transform');
    });

    navLink.on('click', function () {
        html.removeClass("scroll-lock");
        burger.removeClass('active');
        nav.toggleClass('nav-active');
        mobileSearch.toggleClass('nav-active');
        burger.toggleClass('transform');
    });


    //MOBILE SEARCH

    var mobileSearchInput = mobileSearch.find('input');
    var mobileSearchTrigger = $('.navbar-search-trigger');
    var mobileSearchOriginalLink = mobileSearchTrigger.data('original-link');


    $(window).on('load', function () {
        mobileSearchInput[0].value = "";
    })

    mobileSearchInput.on('change, keyup', function (e) {
        var inputValue = mobileSearchInput[0].value;
        var queryString = mobileSearchOriginalLink + '?q=' + inputValue;

        mobileSearchTrigger.attr('href', queryString);

    });

    mobileSearchTrigger.on('click', function (e) {
        if (mobileSearchInput[0].value.length < 1) {
            e.preventDefault();
        }
    });

    $('.notification-bar .close-notification').on('click', function() {
        $(this).parent().addClass('hidden');
        document.cookie = "notification_url=" + $(this).parent().data('id');
    });

})(jQuery);